// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5ca65d21","455":"756c8da2"}[chunkId] + ".chunk.js";
};